var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstallerInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_user_full_information_103769",
    transform: "translate(-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background",
    transform: "translate(6.345)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2078",
    "data-name": "Rectangle 2078",
    width: 24,
    height: 21,
    transform: "translate(-0.345)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "user_x5F_full_x5F_information"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1784",
    "data-name": "Path 1784",
    d: "M16,6a3,3,0,1,0-3-3A3,3,0,0,0,16,6Zm6,4.059V10a1.959,1.959,0,0,0-2-2H12a1.959,1.959,0,0,0-2,2v4a1.758,1.758,0,0,0,2,2v4h8.949l.363-4.675C22.251,15.657,22.329,10.022,22,10.059ZM16.115,19C16.124,15.2,16.124,22.8,16.115,19Z",
    fill: "#f37320"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    transform: "translate(14 6)",
    fill: "#fff",
    stroke: "#f37320",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1785",
    "data-name": "Path 1785",
    d: "M22,28h2V22H22Zm0-10v2h2V18Z",
    transform: "translate(-2 -10)",
    fill: "#f37320"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallerInfo);
export default __webpack_public_path__ + "static/media/installerInfo.050f6e5004659c7ef4bdba59f184583b.svg";
export { ForwardRef as ReactComponent };